import { type FC, type ReactNode } from "react";
import * as Styled from "./Homepage.styled";

type HomepageSmartActionsPanelProps = {
    isReady: boolean;
    isUfType: boolean;
    actionsContent?: ReactNode;
    questionnaireContent?: ReactNode;
    warningsContent?: ReactNode;
};

export const HomepageSmartActionsPanel: FC<HomepageSmartActionsPanelProps> = ({
    isReady,
    isUfType,
    actionsContent,
    questionnaireContent,
    warningsContent,
}) => {
    if (!isReady) {
        return (
            <>
                <Styled.SmartActionsRow>
                    <Styled.SmartActionSkeleton variant="rounded" />
                    <Styled.SmartActionSkeleton variant="rounded" />
                    <Styled.SmartActionSkeleton variant="rounded" />
                </Styled.SmartActionsRow>
                {isUfType && (
                    <Styled.QuestionnaireSkeletonRow>
                        <Styled.QuestionnaireSkeleton variant="rounded" />
                    </Styled.QuestionnaireSkeletonRow>
                )}
            </>
        );
    }

    return (
        <Styled.SmartActionsPanelColumn>
            <Styled.SmartActionsContentRow>{actionsContent}</Styled.SmartActionsContentRow>
            {questionnaireContent && (
                <Styled.SmartActionsQuestionnaireWrapper>{questionnaireContent}</Styled.SmartActionsQuestionnaireWrapper>
            )}
            {warningsContent && <Styled.SmartActionsWarningsColumn>{warningsContent}</Styled.SmartActionsWarningsColumn>}
        </Styled.SmartActionsPanelColumn>
    );
};
